import CryptoJs from "crypto-js";
import { tokenParser } from "./tokenParser";

export function checkUserLoginState() {
  return localStorage.getItem("token");
}
export function getUserAuthorities() {
  return localStorage.getItem("authorities");
}

/**
 * pases JWT token returns JSON object
 * @param token
 */
function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
}

/**
 * accepts access token and decode the values and updates the user data in local storage
 * @param token
 * @returns {Promise}
 */
export function updateUserLoginState(token) {
  return new Promise((resolve, reject) => {
    try {
      localStorage.setItem("token", token);
      if (token) {
        const decodedValue = parseJwt(token);
        if (decodedValue && decodedValue.user_name) {
          localStorage.setItem("userName", decodedValue.user_name);
        } else if (decodedValue && decodedValue.mobile) {
          localStorage.setItem("userName", decodedValue.mobile);
        }
        const authorities = tokenParser(decodedValue.authorities);
        localStorage.setItem("authorities", JSON.stringify(authorities));
        resolve(authorities);
      } else {
        localStorage.setItem("userName", token);
        localStorage.setItem("authorities", token);
        localStorage.setItem("userId", token);
        resolve(true);
      }
    } catch (err) {
      reject(err);
    }
  });
}

export function encryptString(stringToEncrypt) {
  const key = CryptoJs.enc.Utf8.parse("web_chalo_appkey");
  // var iv=CryptoJs.enc.Utf8.parse('7061737323313233');
  const encryptedString = CryptoJs.AES.encrypt(stringToEncrypt, key, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.ZeroPadding,
  });
  return encryptedString.toString();
}

export function decryptString(encryptedString) {
  const key = CryptoJs.enc.Utf8.parse("web_chalo_appkey");

  const decrypted = CryptoJs.AES.decrypt(encryptedString, key, {
    mode: CryptoJs.mode.ECB,
    padding: CryptoJs.pad.ZeroPadding,
  });
  return decrypted.toString(CryptoJs.enc.Utf8);
}
